import { IAddress } from '@r1-frontend/shared/types/IAddress';

export const getAddressByStr = (address: IAddress | null): string => {
    if (!address) {
        return '';
    }

    const { city, street, house, flat } = address;

    if (!city || !street || !house) {
        return '';
    }

    return `г.\u00A0${city.label}, ул.\u00A0${street.label},\u00A0${house.label},\u00A0${flat || ''}`;
};
